/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mission Impact Auth API
 * OpenAPI spec version: v1
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { LanguageResponse } from '../missionImpactAuthAPI.schemas';

import { instance } from '../../mutator-auth';
import type { ErrorType } from '../../mutator-auth';

/**
 * Returns the list of all supported languages for the application.
 * @summary Get supported languages
 */
export const getLanguages = (signal?: AbortSignal) => {
  return instance<LanguageResponse[]>({ url: `/v1/languages`, method: 'GET', signal });
};

export const getGetLanguagesQueryKey = () => {
  return [`/v1/languages`] as const;
};

export const getGetLanguagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getLanguages>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguages>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLanguagesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLanguages>>> = ({ signal }) =>
    getLanguages(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLanguages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetLanguagesQueryResult = NonNullable<Awaited<ReturnType<typeof getLanguages>>>;
export type GetLanguagesQueryError = ErrorType<unknown>;

export function useGetLanguages<
  TData = Awaited<ReturnType<typeof getLanguages>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguages>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLanguages>>,
          TError,
          Awaited<ReturnType<typeof getLanguages>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLanguages<
  TData = Awaited<ReturnType<typeof getLanguages>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguages>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLanguages>>,
          TError,
          Awaited<ReturnType<typeof getLanguages>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLanguages<
  TData = Awaited<ReturnType<typeof getLanguages>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguages>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get supported languages
 */

export function useGetLanguages<
  TData = Awaited<ReturnType<typeof getLanguages>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguages>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetLanguagesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
